import { BiopsySiteType } from 'interfaces/biopsySiteType';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getBiopsySiteTypes = () => {
  return apiRequestHandlerPromise<BiopsySiteType[]>({
    url: `biopsy_site_types`,
    method: 'GET',
  });
};
